<script>
import {
  bApp,
  insTypeOrders,
  insTypeName,
  instypeSummary,
  accShowKeys,
  addAndTakeHead
} from 'base/config'
import {
  formatTenThousand,
  formatASCII,
  formatAddAndTakeText,
  formatLiabilitiesData
} from 'common/js/format'
import {
  setPreValue,
  haveDisease,
  haveShowProductName,
  getTradesIndex,
  stuffingTemplateIns
} from './common'
import Insurance from 'base/model/insurance'
import Emitter from 'common/js/emitter'
import { toggleClass } from 'common/js/dom'
import { getUrlParam } from 'common/js/common'
import ToggleDesc from 'components/toggleDesc/toggleDesc'

const ZJLQ_TYPE = '万能账户'
const ZJLQ_CODE_TYPE = 7 // 万能账户
const showKeys = [
  'headline',
  'description1',
  'description2',
  'liabilityImg',
  'comment',
  'extraDesc'
]
const NCP_ID = 152

export default {
  components: {
    ToggleDesc
  },
  mixins: [Emitter],
  props: {
    temp: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
    productNameList: {
      type: Object,
      default: () => ({})
    },
    showType: {
      type: Number,
      default: 0
    },
    kind: {
      type: Number,
      default: 0
    },
    miniprogram: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isDescShow: []
    }
  },
  methods: {
    /**
     * 显示/隐藏 责任
     * @param  {Object} data
     */
    toggleDesc (data) {
      const { isShow, productIndex, insuranceIndex } = data
      this.isDescShow[productIndex].splice(insuranceIndex, 1, isShow)
    },
    syncToggleDesc (data) {
      const { productIndex, insuranceIndex } = data
      const isShow = !this.isDescShow[productIndex][insuranceIndex]
      this.toggleDesc({
        isShow,
        ...data
      })
      this.syncDelta({
        pbData: {
          isDescShow: {
            isShow,
            ...data
          }
        }
      })
    },
    toggleInstypeDesc (dom) {
      dom.parentNode && toggleClass(dom.parentNode, 'ins-desc-show')
    },
    /**
     * 显示/隐藏 病种
     * @param  {Object} event
     * @param  {Object} path  [路径]
     */
    clickHandler (event, path) {
      this.dispatch('InsResult', 'open-disease', path)
    },
    handleOpenTerms (event, id) {
      this.dispatch('InsResult', 'open-terms', id)
    },
    /**
     * 创建险种
     * @param  {Array} template
     * @return {VNode}
     */
    _createInsVNode (template) {
      let prodAry = []
      let {
        __c,
        // , insuranceTypeId
        temp: { trades },
        productNameList,
        miniprogram,
        isPolicyCheck
      } = this
      // 产品数
      let productsLen = template.length
      // 产品
      template.forEach((products, index) => {
        let insAry = []
        let tradesVNode
        // 产品 - <险种>
        products.forEach((item, insIdx) => {
          let ins = item.ins
          let productId = item.productId
          let accountMap = item.accountMap
          let bLastInsHideDesc = false
          let liabilities = ins.liabilities
          let insChilds = []
          let bCompleteIns = false

          // 条款 VNode
          // let termVNode = __c('a', {
          //   class: 'term-link after-bdr',
          //   attrs: {
          //     'data-stat-id': 'tkxq',
          //     'data-stat-ep': JSON.stringify({
          //       productId: insuranceTypeId,
          //     }),
          //   },
          //   on: {
          //     click: this.handleOpenTerms.bind(this, event, ins.insuranceId),
          //   },
          //   domProps: {
          //     innerHTML: '条款',
          //   },
          // })
          // termVNode
          let headMoreChilds = []
          let { bDisease, bHideDesc } = haveDisease(liabilities)

          // 病种 VNode
          if (bDisease) {
            let diseaseBtnVNode = __c('a', {
              class: 'dis-link after-bdr',
              domProps: {
                innerHTML: '病种'
              },
              on: {
                click: this.clickHandler.bind(this, event, item.insDisease)
                // this.toggleDis.bind(this, item.disease)
              }
            })
            headMoreChilds.push(diseaseBtnVNode)
          }
          let insTitleVNode = __c('h3', {
            class: 'ins-title',
            domProps: {
              innerHTML: ins.insuranceName
            }
          })
          let insMoreVNode = __c(
            'div',
            {
              class: headMoreChilds.length ? 'ins-more' : 'ins-none'
            },
            headMoreChilds
          )
          // 险种 head
          let insHeadVNode = __c(
            'div',
            {
              class: 'ins-name'
            },
            [insTitleVNode, insMoreVNode]
          )
          insChilds.push(insHeadVNode)

          // 险种 body
          if (ins && Array.isArray(liabilities) && liabilities.length) {
            // 正常险种
            let insBodyChilds = this._createLiabilities(productId, liabilities)
            let insBodyVNode = __c(
              'div',
              {
                class: 'ins-bd'
              },
              insBodyChilds
            )
            insChilds.push(insBodyVNode)
            bCompleteIns = true
            bHideDesc = insBodyChilds.some(i => i.data.class === 'comment')
          }
          // 追加领取
          if (accountMap) {
            let insAddAndTakeChilds = this._createAddAndTake(accountMap)
            if (insAddAndTakeChilds.length) {
              let insAddAndTakeVNode = __c(
                'div',
                {
                  class: 'ins-bd add-take'
                },
                insAddAndTakeChilds
              )
              insChilds.push(insAddAndTakeVNode)
              bCompleteIns = true
            }
          }

          // 险种 foot
          let insFootVNode
          if (bHideDesc) {
            insFootVNode = __c(ToggleDesc, {
              on: {
                toggle: this.syncToggleDesc.bind(this, {
                  productIndex: index,
                  insuranceIndex: insIdx
                })
              }
            })
            // 交易且有隐藏文案
            bLastInsHideDesc = true
            insChilds.push(insFootVNode)
          }

          // 交易
          // 产品中最后险种
          if (
            Array.isArray(trades) &&
            trades.length >= 1 &&
            productsLen > 1 &&
            insIdx === 0 &&
            !miniprogram &&
            !isPolicyCheck
          ) {
            // 是否交易产品
            let tradesIdx = getTradesIndex(productId, trades)
            if (tradesIdx > -1) {
              let tradesInfo = trades[tradesIdx].productInfo
              if (tradesInfo && tradesInfo.tradeUrl) {
                const cpId = getUrlParam('productId', tradesInfo.tradeUrl)
                tradesVNode = __c('div', {
                  class: bLastInsHideDesc ? 'trades-inner-wrap' : 'trades-wrap',
                  domProps: {
                    innerHTML: `<a class="trades-btn" href="${
                      bApp ? tradesInfo.tradeUrl : tradesInfo.shareTradeUrl
                    }" data-stat-id="lktb" data-stat-ep='${JSON.stringify({
                      cpId: cpId
                    })}'>立即投保</a>`
                  }
                })
                insChilds.push(tradesVNode)
              }
            }
          }

          let insVNode
          bCompleteIns &&
            insChilds.length &&
            (insVNode = __c(
              'div',
              {
                class: {
                  'ins-box': true,
                  'ins-desc-show': this.isDescShow[index][insIdx]
                }
              },
              insChilds
            ))
          bCompleteIns && insChilds.length && insAry.push(insVNode)
        })
        let prodNameVNode = __c('h3', {
          class: 'prod-name',
          domProps: {
            innerHTML: productNameList[products[0].productId]
          }
        })
        let prodMainVNode = __c(
          'div',
          {
            class: 'prod-main'
          },
          insAry
        )
        let prodVNodes = __c(
          'section',
          {
            class: 'prod-box'
          },
          [prodNameVNode, prodMainVNode]
        )
        prodAry.push(prodVNodes)
      })

      return __c(
        'article',
        {
          class: 'des-box'
        },
        prodAry
      )
    },
    /**
     * 创建责任
     * @param  {Array} template
     * @return {VNode}
     */
    _createInsTypeVNode (template, ignore) {
      let {
        sortList,
        productNameList,
        temp: { insuranceTypeId },
        __c,
        _createLiabilities,
        _createAddAndTake,
        _createProductVNode
      } = this

      // const tLen = template.length
      // const insTypeOrder = insTypeOrders[categorySort || 'normal']

      let instypeAry = []
      // let bToggleDesc = false

      template.forEach((instype, idx) => {
        const insTypeKind = sortList[idx]
        const bProductShow = haveShowProductName(
          instype,
          insTypeKind,
          productNameList
        )
        // const bInstypeSummary = false

        let insAry = []
        let liabTypeName = ''
        let bInstypeHideDesc = false
        let bInstypeDisease = false
        let bAddAndTake = 0
        let itDisease = []
        let preProductName = null

        instype.forEach((ins, lidx) => {
          // 类别名 设置一次
          if (lidx === 0) {
            liabTypeName = ins.liabTypeName
          }
          if (ignore && !ins.ignore) return
          const liabilities = ins.liabilities
          const productId = ins.productId
          const productName = productNameList[productId]

          let insChilds = []
          let bInsBodyVNode = false

          if (bProductShow && preProductName != productName) {
            insAry = insAry.concat(
              _createProductVNode(productName, preProductName)
            )
            preProductName = productName
          }

          itDisease.push(ins.itDisease)

          // 条款 VNode
          let termVNode = __c('a', {
            class: 'term-link',
            attrs: {
              'data-stat-id': 'tkxq',
              'data-stat-ep': JSON.stringify({
                productId: insuranceTypeId
              })
            },
            on: {
              click: this.handleOpenTerms.bind(this, event, ins.insuranceId)
            },
            domProps: {
              innerHTML: '条款'
            }
          })
          let headChilds = [ins.insuranceName, termVNode]
          let accountMap = ins.accountMap

          let { bDisease, bHideDesc } = haveDisease(liabilities)

          // 病种 VNode
          if (bDisease) {
            // let diseaseBtnVNode = create('a', {
            //   class: 'dis-link',
            //   domProps: {
            //     innerHTML: '病种'
            //   },
            //   on: {
            //     click: this.toggleDis.bind(this, ins.disease)
            //   }
            // })
            // headChilds.push(diseaseBtnVNode)

            !bInstypeDisease && (bInstypeDisease = true)
          }
          // 险种 head
          let insHeadVNode = __c(
            'h5',
            {
              class: 'ins-name'
            },
            headChilds
          )
          insChilds.push(insHeadVNode)

          // 险种head都隐藏
          // bHideDesc = true;

          // 险种 body
          if (liabilities) {
            // 正常险种
            let insBodyChilds = _createLiabilities(productId, liabilities)
            if (insBodyChilds.length) {
              let insBodyVNode = __c(
                'div',
                {
                  class: 'ins-bd'
                },
                insBodyChilds
              )
              insChilds.push(insBodyVNode)
              bInsBodyVNode = true
              // bHideDesc 根据是否有责任内容确定，但一些情况内容是""，实际是没有内容的，不应该显示更多箭头： "∨"
              bHideDesc = insBodyChilds.some(
                item => item.data.class === 'comment'
              )
            }
          }
          // 追加领取
          if (accountMap) {
            let insAddAndTakeChilds = _createAddAndTake(accountMap)
            if (insAddAndTakeChilds.length) {
              let insAddAndTakeVNode = __c(
                'div',
                {
                  class: 'ins-bd add-take'
                },
                insAddAndTakeChilds
              )
              insChilds.push(insAddAndTakeVNode)
              bAddAndTake++
            }
          }

          // 险种 foot
          let insFootVNode
          if (!bInstypeHideDesc && bHideDesc) {
            bInstypeHideDesc = bHideDesc
            insChilds.push(insFootVNode)
          }

          let insVNode
          insChilds.length &&
            bInsBodyVNode &&
            (insVNode = __c(
              'div',
              {
                class: 'ins-box'
              },
              insChilds
            ))

          // 万能账户： 责任+追加领取 都存在则添加
          if (ins.liabTypeName === ZJLQ_TYPE) {
            (bAddAndTake > 0 || bInsBodyVNode) &&
              insChilds.length &&
              insAry.push(insVNode)
          } else {
            insChilds.length && bInsBodyVNode && insAry.push(insVNode)
          }
        })
        // 险种类别名
        // 没有险种信息（追加领取）
        if (insAry.length) {
          const liabTypeNameVNode = __c(
            'span',
            {
              class: 'instype-name-inner'
            },
            liabTypeName
          )
          let instypeNameChild = [liabTypeNameVNode]
          if (insTypeKind == NCP_ID) {
            const iLeftVNode = __c('i', {
              class: 'instype-icon left'
            })
            const iRightVNode = __c('i', {
              class: 'instype-icon right'
            })
            instypeNameChild.unshift(iLeftVNode)
            instypeNameChild.push(iRightVNode)
          }
          if (bInstypeDisease) {
            const instypeDiseaseVNode = __c(
              'a',
              {
                class: 'disease-btn after-bdr',
                on: {
                  click: this.clickHandler.bind(this, event, itDisease)
                }
              },
              '病种'
            )
            instypeNameChild.push(instypeDiseaseVNode)
          }
          const instypeNameVNode = __c(
            'h3',
            {
              class: 'instype-name'
            },
            instypeNameChild
          )
          insAry.unshift(instypeNameVNode)

          const summaryText = instypeSummary[insTypeKind]
          if (summaryText && bProductShow) {
            insAry.push(
              __c(
                'div',
                {
                  class: 'summary'
                },
                summaryText
              )
            )
          }

          // 显示
          if (bInstypeHideDesc) {
            let instypeToggleFootVNode = __c(ToggleDesc, {
              on: {
                toggle: this.toggleInstypeDesc
              }
            })
            insAry.push(instypeToggleFootVNode)
          }

          let sectionClass =
            bAddAndTake > 0
              ? bAddAndTake > 1
                ? 'instype-box addtake-box'
                : 'instype-box addtake-box no-title'
              : 'instype-box'

          let instypeVNodes = __c(
            'section',
            {
              class: bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box'
            },
            insAry
          )

          instypeAry.push(instypeVNodes)
        }
      })

      return __c(
        'article',
        {
          class: 'des-box'
        },
        instypeAry
      )
    },
    /**
     * 创建意外责任
     * @param  {Array} template
     * @return {VNode}
     */
    _createAccidentVNode (template) {
      let prodAry = []
      let {
        __c,
        temp: { username, trades }
      } = this
      // 产品数
      let productsLen = template.length
      // 产品
      template.forEach((products, index) => {
        let insAry = []
        let headlineVNode
        let tradesVNode
        let bProdHideDesc = false

        // 产品 - <险种>
        products.forEach((item, insIdx) => {
          let ins = item.ins
          let productId = item.productId
          let accountMap = item.accountMap
          let bLastInsHideDesc = false
          let liabilities = ins.liabilities
          let insChilds = []
          let bCompleteIns = false

          let { bDisease, bHideDesc } = haveDisease(liabilities)
          // 险种 head
          if (insIdx === 0) {
            headlineVNode = __c('h3', {
              class: 'ins-name after-bd-b',
              domProps: {
                innerHTML:
                  liabilities &&
                  liabilities[insIdx] &&
                  liabilities[insIdx].headline
              }
            })
          }

          // insChilds.push(insHeadVNode)

          // 险种 body
          if (ins && Array.isArray(liabilities) && liabilities.length) {
            // 正常险种
            let insBodyChilds = this._createAccLiabilities(
              productId,
              liabilities
            )
            let insBodyVNode = __c(
              'div',
              {
                class: 'ins-bd'
              },
              insBodyChilds
            )
            insChilds.push(insBodyVNode)
            bCompleteIns = true
          }

          // 追加领取
          // if (accountMap) {
          //   let insAddAndTakeChilds = this._createAddAndTake(accountMap, create)
          //   if (insAddAndTakeChilds.length) {
          //     let insAddAndTakeVNode = create('div', {
          //       class: 'ins-bd add-take'
          //     }, insAddAndTakeChilds)
          //     insChilds.push(insAddAndTakeVNode)
          //     bCompleteIns = true
          //   }
          // }

          // 险种 foot
          // let insFootVNode
          if (bHideDesc && !bProdHideDesc) {
            bProdHideDesc = true
            // insFootVNode = create(ToggleDesc, {
            //   on: {
            //     toggle: this.toggleDesc
            //   }
            // })
            // 交易且有隐藏文案
            // bLastInsHideDesc = true
            // insChilds.push(insFootVNode)
          }

          let insVNode
          bCompleteIns &&
            insChilds.length &&
            (insVNode = __c(
              'div',
              {
                class: 'ins-box'
              },
              insChilds
            ))
          bCompleteIns && insChilds.length && insAry.push(insVNode)
        })

        let prdFootVNode
        if (bProdHideDesc) {
          prdFootVNode = __c(ToggleDesc, {
            on: {
              toggle: this.toggleInstypeDesc
            }
          })
          // 交易且有隐藏文案
          // bLastInsHideDesc = true
          insAry.push(prdFootVNode)
        }

        insAry.unshift(headlineVNode)

        let prodVNodes = __c(
          'section',
          {
            class: 'prod-box'
          },
          insAry
        )
        prodAry.push(prodVNodes)
      })

      return __c(
        'article',
        {
          class: 'acc-box'
        },
        prodAry
      )
    },
    /**
     * 创建责任（普通）
     * @param  {Number} prodId [产品id]
     * @param  {Object} liab   [责任对象]
     * @return {Array}         [VNode, VNode]
     */
    _createLiabilities (prodId, liab) {
      let ret = []
      let { data, __c } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib, idx) => {
        lib &&
          showKeys.forEach((sk, idx) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              if (sk === 'liabilityImg' && Array.isArray(libItem)) {
                resultHTML = ''
                libItem.forEach((item, index) => {
                  resultHTML += `<p><img src="${item}?x-oss-process=image/resize,w_610/quality,Q_80" alt="${index}" /></p>`
                })
              } else {
                try {
                  resultHTML = this.format(prodId, libItem, data)
                } catch (er) {
                  resultHTML = this.formatLow(prodId, libItem, data)
                }
              }
              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                resultHTML = setPreValue(sk, resultHTML)

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML
                  }
                })
                ret.push(libVNode)
              }
            }
          })
      })

      return ret
    },
    /**
     * 创建意外责任
     * @param  {Number} prodId [产品id]
     * @param  {Object} liab   [责任对象]
     * @return {Array}         [VNode, VNode]
     */
    _createAccLiabilities (prodId, liab) {
      let ret = []
      let { data, __c } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib, index) => {
        let accLib = []
        let accLibVNode

        lib &&
          accShowKeys.forEach((sk, idx) => {
            let libItem = lib[sk]
            let bIconfont = false
            if (sk === 'description1') {
              bIconfont = true
            }
            if (libItem) {
              let resultHTML
              try {
                resultHTML = this.format(prodId, libItem, data)
              } catch (er) {
                resultHTML = this.formatLow(prodId, libItem, data)
              }

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                resultHTML = setPreValue(sk, resultHTML)

                if (bIconfont) {
                  resultHTML = `<i class="iconfont icon-${
                    lib['iconfont']
                  }"></i>${resultHTML}`
                }

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML
                  }
                })
                accLib.push(libVNode)
              }
            }
            if (idx === accShowKeys.length - 1 && accLib.length) {
              accLibVNode = __c(
                'div',
                {
                  class: 'acc-lib after-bd-b'
                },
                accLib
              )
            }
          })

        accLibVNode && ret.push(accLibVNode)
      })

      return ret
    },
    /**
     * 创建追加领取
     * @param  {Object} account [追加领取]
     * @return {Array}         [VNode]
     */
    _createAddAndTake (account) {
      let ret = []
      let {
        __c,
        temp: { insuredAge }
      } = this
      let addAndTake = account.addAndTakeData
      let result = {
        add: [],
        take: []
      }
      if (!account || !addAndTake.length) return ret
      if (addAndTake && Array.isArray(addAndTake)) {
        addAndTake.forEach(at => {
          if (Array.isArray(at.adjustData) && at.adjustData.length > 0) {
            result[at.key] = at.adjustData
          }
        })
      }

      let addChilds = []
      let takeChilds = []
      if (result.add.length) {
        let addHeadVNode = __c('div', {
          class: 'description1',
          domProps: {
            innerHTML: addAndTakeHead[0]
          }
        })
        addChilds.push(addHeadVNode)

        result.add.forEach(addItem => {
          let addItemVNode = __c('div', {
            class: 'description2',
            domProps: {
              innerHTML: formatAddAndTakeText('add', addItem, insuredAge)
            }
          })
          addChilds.push(addItemVNode)
        })
        let addVNode = __c(
          'div',
          {
            class: 'account-item'
          },
          addChilds
        )
        ret.push(addVNode)
      }
      if (result.take.length) {
        let takeHeadVNode = __c('div', {
          class: 'description1',
          domProps: {
            innerHTML: addAndTakeHead[1]
          }
        })
        takeChilds.push(takeHeadVNode)
        result.take.forEach(addItem => {
          let addItemVNode = __c('div', {
            class: 'description2',
            domProps: {
              innerHTML: formatAddAndTakeText('take', addItem, insuredAge)
            }
          })
          takeChilds.push(addItemVNode)
        })
        let takeVNode = __c(
          'div',
          {
            class: 'account-item'
          },
          takeChilds
        )
        ret.push(takeVNode)
      }
      return ret
    },
    /**
     * 创建产品名节点
     * @param  {String} name [名称]
     * @param  {Bollean} segm [分割]
     * @return {Array}      [list[VNode]]
     */
    _createProductVNode (name, segm) {
      let rst = []
      let { __c } = this
      if (segm) {
        rst.push(
          __c('div', {
            class: 'product-name-line after-bd-b'
          })
        )
      }
      rst.push(
        __c(
          'h4',
          {
            class: 'product-name'
          },
          name
        )
      )

      return rst
    },
    /**
     * 转义字符串模版
     * @param  {Number} prodId   [产品id]
     * @param  {String} template [pre模版]
     * @param  {Object} data     [计算数据]
     * @return {String}          [模版]
     */
    format (prodId, template, data) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this.formatFnCenter `' + template + '`;'
      )
      return formatASCII(g.apply(self, dataList))
    },
    /**
     * ios8-5c fix (_format) 方法
     */
    formatLow (prodId, template, data) {
      let self = this
      let temps = template.split(/\$\{(\w?[^\}]*)\}/g)
      let match = template.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g)

      let dataList
      let keys = Object.keys(data)
      let result
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      if (match) {
        for (var i = 1; i < temps.length; i += 2) {
          let ret = new Function(
            keys.join(','),
            'return ' + temps[i] + ';'
          ).apply(self, dataList)
          // 金额显示整万
          if (temps[i + 1].match(/元/)) {
            ret = String(formatTenThousand(ret))
          } else if (typeof ret === 'string' && ret.match(/元/)) {
            // 针对三元运算符内整万显示
            const re = /\d+.\d+|\d+元/
            const matchMoney = ret.match(re)
            if (matchMoney && matchMoney[0]) {
              ret = ret.replace(re, String(formatTenThousand(matchMoney[0])))
            }
          }
          ret = '' + ret
          // 金额显示保留2位小数
          if (!isNaN(Number(ret)) && ret.split('.')[1]) {
            ret =
              ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
          }
          temps[i] = ret
        }
        result = temps.join('')
      } else {
        result = template
      }

      return formatASCII(result)
    },
    /**
     * 转义，公共函数
     * @param  {[type]} templateData [pre模版，数据]
     * @return {[type]}              [模版]
     */
    formatFnCenter (templateData) {
      var resultTemp = templateData[0]
      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])
        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(formatTenThousand(arg))
        } else if (arg.match(/元/)) {
          // 针对三元运算符内整万显示
          // 正则匹配
          // 同一条责任多个数据转换
          const re = /(\d+\.\d+|\d+)元/g
          const matchMoney = arg.match(re)
          if (matchMoney) {
            if (matchMoney.length > 1 && matchMoney[1]) {
              arg = arg.replace(re, function () {
                // arguments 对应各个匹配的字符
                return `${String(
                  formatTenThousand(arguments[0].match(/(\d+\.\d+|\d+)元/)[1])
                )}元`
              })
            } else {
              const money = Array.isArray(matchMoney)
                ? matchMoney[0]
                : matchMoney
              arg = arg.replace(re, function () {
                // matchMoney = arguments[0]元
                return `${String(
                  formatTenThousand(money.match(/(\d+\.\d+|\d+)元/)[1])
                )}元`
              })
            }
          }
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    }
  },
  // 依据大类型
  render: function (createElement) {
    this.__c = createElement
    const {
      kind,
      showType,
      temp: {
        descShow,
        liabilities,
        categorySort,
        accountMap,
        categorySortList
      },
      _createInsVNode,
      _createInsTypeVNode,
      _createAccidentVNode
    } = this
    this.isDescShow = descShow
    this.isPolicyCheck = getUrlParam('pbType') === 'annual_survey'
    const _categorySort =
      Object.keys(insTypeOrders).indexOf(categorySort) >= 0
        ? categorySort
        : 'normal'
    const sortList = (this.sortList =
      Array.isArray(categorySortList) && categorySortList.length
        ? categorySortList
        : insTypeOrders[_categorySort])
    // diseasesPath,
    const { insList, instypeList, accInsList } = formatLiabilitiesData(
      liabilities,
      sortList,
      insTypeName,
      accountMap
    )

    // console.log(['diseasesPath', diseasesPath])
    // console.log(['insList', insList])
    // console.log(['instypeList', instypeList])
    // console.log(['accInsList', accInsList])
    const bAcc = accInsList[0] && accInsList[0].length

    this.dispatch('InsResult', 'set-accIns', !!bAcc)
    this.dispatch('InsResult', 'set-instype', instypeList)

    if (kind) {
      return kind === 1
        ? createElement('div', { class: 'genre-box' }, [
          _createAccidentVNode(accInsList),
          _createInsTypeVNode(instypeList, true)
        ])
        : createElement('div', { class: 'genre-box' }, [
          _createInsTypeVNode(instypeList)
        ])
    }
    if (showType === 0) {
      return _createInsVNode(insList)
    } else {
      return createElement(
        'div',
        {
          class: 'genre-box'
        },
        [_createAccidentVNode(accInsList), _createInsTypeVNode(instypeList)]
      )
    }
  }
}
</script>
